export const AD_HAS_DESIGN = 'adHasDesign';
export const AD_INVALID_PRODUCT = 'adInvalidProduct';
export const AD_REPLACE_DESIGN = 'adReplaceDesign';
export const ADD_PRODUCT_MISSING_AREAS = 'addProductMissingAreas';
export const BUY_BLANK_FROM_STORE = 'buyBlankFromStore';
export const CHANGE_PRINT_METHOD_WARNING = 'changePrintMethodWarning';
export const COLOR_CHANGE_PANTONE_WARNING = 'colorChangePantoneWarning';
export const DEBOSS_DESIGN_TIPS = 'debossDesignTips';
export const DELETE_SLEEVE_DESIGN_WARNING = 'needDeleteSleeveDesignWarning';
export const DESIGN_LOAD_ERROR = 'designLoadError';
export const EMBOSS_DESIGN_TIPS = 'embossDesignTips';
export const EMBROIDERY_DESIGN_TIPS = 'embroideryDesignTips';
export const EXIT_AD = 'exitAD';
export const EXIT_CONFIRMATION = 'exitConfirmation';
export const FAILED_LOAD_SLEEVE_PRODUCT_IMAGE = 'failedLoadSleeveProductImage';
export const FONT_MIN_HEIGHT_ERROR = 'fontMinHeightError';
export const FONT_OUTLINE_UNSUPPORTED = 'fontOutlineUnsupported';
export const FONT_PIXEL_WIDTH_ERROR = 'fontPixelWidthError';
export const FUNDRAISING_LOAD_ERROR = 'fundraisingLoadError';
export const INACTIVE_PRODUCT = 'inactiveProduct';
export const INACTIVE_PRODUCT_MAX_NAME_LENGTH = 36;
export const INCOMPATIBLE_NAMES_AND_NUMBERS = 'incompatibleNamesAndNumbers';
export const INVALID_UPLOAD = 'invalidUpload';
export const LASER_ENGRAVING_DESIGN_TIPS = 'laserEngravingDesignTips';
export const LOAD_DESIGN_WITH_DIRTY_DESIGN = 'loadDesignWithDirtyDesign';
export const MIN_QTY_INTERNATIONAL_SHIPPING = 'minQtyInternationalShipping';
export const MULTI_STYLE_NAMES_AND_NUMBERS = 'mutliStyleNamesAndNumbers';
export const NAMES_NUMBERS_MULTI_COLOR = 'namesAndNumbersMultipleColors';
export const PANTONE_DISABLED_WARNING = 'pantoneDisabledWarning';
export const PERSONALIZATION_NOT_SUPPORTED_WARNING =
  'personalizationNotSupportedWarning';
export const QUOTE_WITHOUT_DESIGN = 'quoteWithoutDesign';
export const REMOVE_PANTONE_WARNING = 'removePantoneWarning';
export const RETIRED_PRODUCT_COLOR = 'retiredProductColor';
export const SERVICE_UNAVAILABLE = 'serviceUnavailable';
export const SHOPPING_CART_CONFIRM = 'shoppingCartConfirm';
export const SHOPPING_CART_CONFIRM_DIRTY = 'shoppingCartConfirmDirty';
export const SHOPPING_CART_CONFIRM_EMPTY = 'shoppingCartConfirmEmpty';
export const SIZES_UNAVAILABLE_WARNING = 'sizesUnavailableWarning';
export const STYLE_LOAD_ERROR = 'styleLoadError';
export const SWAP_PRODUCT_MISMATCHED_AREAS = 'swapProductMismatchedAreas';
export const SWAP_PRODUCTS_WARNING = 'swapProductsWarning';
export const SWAP_INCOMPATIBLE_PRODUCTS_WARNING =
  'swapIncompatibleProductsWarning';
export const TOO_MANY_COLORS = 'tooManyColors';
export const TOO_MANY_PRODUCTS = 'tooManyProducts';
export const TOO_MANY_SLEEVE_COLORS = 'tooManySleeveColors';
export const UNSUPPORTED_DESIGN_AREAS_WARNING = 'unsupportedDesignAreasWarning';
export const UPLOAD_DIMENSIONS_TOO_LARGE = 'uploadDimensionsTooLarge';
export const UPLOAD_FILE_UNSUPPORTED = 'uploadFileUnsupported';
export const UPLOAD_FILESIZE_TOO_LARGE = 'uploadFilesizeTooLarge';
